import { api } from "@/api/axios.ts";
import { ApiAiAssistantThread, ApiAiAssistantThreadFull } from "@/types/ai-assistant.types.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import { GenericAbortSignal } from "axios";

export const apiAiAssistant = {
  getThreads: (signal?: GenericAbortSignal) => {
    return api.get<ApiAiAssistantThread[]>("/api/v1/ai-assistant/threads", {}, signal);
  },
  // Сообщения уходят обратно в чат: даты во входах инструментов должны остаться строками, как в потоке.
  getThread: (id: number, signal?: GenericAbortSignal) => {
    return api.get<ApiAiAssistantThreadFull>(`/api/v1/ai-assistant/threads/${id}`, {}, signal, {
      keepDateStrings: true,
    });
  },
  stopReply: (threadId: number) => {
    return api.post<ApiOperationResult>(`/api/v1/ai-assistant/chat/${threadId}/stop`, {});
  },
  deleteThread: (id: number) => {
    return api.delete<ApiOperationResult>(`/api/v1/ai-assistant/threads/${id}`);
  },
};
